import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Services from '../../api/Services';
import ServiceSidebar from './sidebar'
import Contact from './contact';
import simg1 from '../../images/service-single/img-1.png'
import simg2 from '../../images/service-single/img-2.png'
import Footer from '../../components/footer/Footer';
import logo from '../../images/gattomioNero.png'

const ServiceSinglePage = (props) => {
    const { slug } = useParams()

    const serviceDetails = Services.find(item => item.slug === slug)

    return (
        <Fragment>
            <Navbar Logo={logo} hclass={'wpo-site-header'} />
            <PageTitle pageTitle={serviceDetails.title} pagesub={'Kleeo'} />
            <div className="wpo-service-single-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12">
                            <div className="wpo-service-single-wrap">
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-single-main-img">
                                        <img src={serviceDetails.simage} alt="" />
                                    </div>
                                    <div className="wpo-service-single-title">
                                        <h3>{serviceDetails.title}</h3>
                                    </div>
                                    <p>
                                        Kleeo non è una semplice lettiera, ma un ecosistema di benessere progettato per integrarsi
                                        perfettamente nella tua casa. Con un volume interno di <strong>65 litri</strong> e
                                        un design a corpo fisso (Integrated bucket body), offre al tuo gatto uno spazio ampio,
                                        sicuro e sempre pulito, eliminando il compito più gravoso della gestione quotidiana.
                                    </p>
                                    <p>
                                        Costruita con materiali di alta qualità (PP, PS, POM) e
                                        certificata <strong>CE e ROHS</strong>, Kleeo garantisce performance
                                        costanti nel tempo. Ogni componente è stato testato per resistere
                                        all'uso intensivo, inclusi test di resistenza agli urti da 760mm,
                                        per assicurare una robustezza senza precedenti nella categoria.
                                    </p>
                                    <div className="row mt-4">
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg1} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg2} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="wpo-service-single-item list-widget">
                                    <div className="wpo-service-single-title">
                                        <h3>Specifiche Tecniche d'Avanguardia</h3>
                                    </div>
                                    <p>Abbiamo progettato Kleeo per superare gli standard di mercato, puntando su tre pilastri: silenziosità, durata e capienza.</p>
                                    <ul>
                                        <li><strong>Silenzio Assoluto:</strong> Funzionamento sotto i 45dBA, impercettibile anche di notte.</li>
                                        <li><strong>Vano Extra-Large:</strong> 65 Litri di volume per il massimo comfort del gatto.</li>
                                        <li><strong>Motore Industriale:</strong> Longevità garantita per oltre 2.000 ore di lavoro.</li>
                                        <li><strong>Igiene Semplificata:</strong> Tamburo interno "Removable and washable" per una pulizia profonda.</li>
                                        <li><strong>Design Compatto:</strong> Dimensioni reali 480*533*510mm per ottimizzare gli spazi.</li>
                                    </ul>
                                </div>
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-single-title">
                                        <h3>Il Nostro Approccio alla Sicurezza</h3>
                                    </div>
                                    <p>
                                        La sicurezza del tuo gatto è la nostra priorità tecnica.
                                        Il design a cupola fissa impedisce qualsiasi rischio di intrappolamento
                                        durante il ciclo di rotazione interno. Il pannello operatore con switch a sfioramento (Touch switch)
                                        permette un controllo immediato, mentre l'alimentazione
                                        a 12V garantisce un consumo energetico minimo (Max 18W) e la massima sicurezza elettrica in ambiente domestico.
                                    </p>
                                </div>
                                <div className="wpo-service-single-item list-widget">
                                    <div className="wpo-service-single-title">
                                        <h3>Cosa troverai nella confezione</h3>
                                    </div>
                                    <ul>
                                        <li>Unità Kleeo completamente assemblata.</li>
                                        <li>Alimentatore DC 12V con cavo da 1.5 metri.</li>
                                        <li>Manuale tecnico di installazione rapida.</li>
                                        <li>Certificazioni di qualità e sicurezza CE/ROHS incluse.</li>
                                    </ul>
                                </div>

                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-contact-area">
                                        <div className="wpo-contact-title">
                                            <h2>Hai domande su Kleeo?</h2>
                                            <p>Il nostro team di esperti è a tua disposizione per approfondire le specifiche tecniche.</p>                                        </div>
                                        <div className="wpo-contact-form-area">
                                            <Contact />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ServiceSidebar />
                    </div>
                </div>
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;



